const container = (styles: object) => {
  return {
    ...styles,
    maxWidth: '405px',
    marginTop: '21px',
  }
}

export default container
